// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__MgyDS","inside":"Circle_inside__qKK1e"};